import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type OwnProps = {
  id: number;
  name: string;
  logo: string | null;
  pathName: string;
};

const RecommendedRetailer = memo(({ name, logo, pathName, id }: OwnProps) => {
  const { linkTo, t } = useContext(AppContext);

  return (
    <S.RecommendedRetailerExpansion to={linkTo('brand', { pathName, id })}>
      <S.Wrapper>
        {t('store', 'store.recommended-retailer', { brand: name })}
        {logo ? <img src={logo} alt={name} /> : null}
      </S.Wrapper>
    </S.RecommendedRetailerExpansion>
  );
});

export default RecommendedRetailer;
